const toolbox = {
  viewtitle: 'Toolbox',
  coupons: {
    acymailing: 'Acy_Backupmonkey',
    akeeba: 'BACKUPMONKEY1911',
    dpcalendar: 'BACKUPMONKEYFORDP',
    easycontracts: 'monkey',
    easyrechtssicher: 'monkey',
    jtraining: 'KLETTERAFFE2020',
    kicktemp: 'MonkeyLove',
    rsform: 'BCKUPMKRSFPDSC',
    rsfirewall: 'BCKUPMKRSFRWDSC',
    techjoomla: 'TJBACKUPMONKEY',
    mittpwa: 'miTTPWAMonkey'
  }
}

export default toolbox
